var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psReportsPanel"},[_c('ps-upper-bar',{attrs:{"site":{ site: 'Reportes' }}}),_c('ps-reports-item',{attrs:{"reportName":"Altas y Bajas","path":"altas-y-bajas"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }